/* eslint-disable @typescript-eslint/no-explicit-any */
import config from '../boot/config'

const checkLogLevel = (logLabel?: string) => {
	if (!logLabel) logLabel = 'trace'
	logLabel = logLabel.toUpperCase()
	if (config.logLevel == 'error') {
		if (logLabel == 'TRACE' || logLabel == 'DEBUG' || logLabel == 'INFO' || logLabel == 'WARNING') return false
	}
	if (config.logLevel == 'warning') {
		if (logLabel == 'TRACE' || logLabel == 'DEBUG' || logLabel == 'INFO') return false
	}
	if (config.logLevel == 'info') {
		if (logLabel == 'TRACE' || logLabel == 'DEBUG') return false
	}
	if (config.logLevel == 'debug') {
		if (logLabel == 'TRACE') return false
	}
	return true
}

export default class Log {
	static error(msg: string, e: string | object, ...args: any[]) {
		if (!e) e = ''
		if (!args.length) args = []
		if (typeof msg == 'object') msg = JSON.stringify(msg)
		console.error(`[ERR]: ${msg.toString()}`, e, args)
	}
	static warn(msg: string, e: string | object, ...args: any[]) {
		if (!checkLogLevel('warning')) return
		if (!e) e = ''
		if (!args.length) args = []
		if (typeof msg == 'object') msg = JSON.stringify(msg)
		console.warn(`[WARN]: ${msg.toString()}`, e, args)
	}
	static trace(msg: string, e: string | object, ...args: any[]) {
		if (!checkLogLevel('trace')) return
		if (!e) e = ''
		if (!args.length) args = []
		if (typeof msg == 'object') msg = JSON.stringify(msg)
		console.log(`[TRACE]: ${msg.toString()}`, e, args)
	}
	static info(msg: string, e: string | object, ...args: any[]) {
		if (!checkLogLevel('info')) return
		if (!e) e = ''
		if (!args.length) args = []
		if (typeof msg == 'object') msg = JSON.stringify(msg)
		console.log(`[INFO]: ${msg.toString()}`, e, args)
	}
}

export { Log }
